import { useSeo } from "@/hooks/useSeo";
import { PageHero, CTABand } from "@/components/Layout";
import { faqs, business } from "@/data/site";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = () => {
  useSeo({
    title: `FAQ — Plumbing, Electrical & HVAC Questions | ${business.name} New York`,
    description: "Answers to common questions about our New York plumbing, electrical, and HVAC services — pricing, licensing, emergency service, financing, and more.",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  });

  return (
    <>
      <PageHero eyebrow="Help Center" title="Frequently Asked Questions" subtitle="Everything you need to know about working with our New York home service team." />
      <section className="max-w-3xl mx-auto px-4 py-16 sm:py-24" data-testid="faq-list">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border border-[#E2E8F0] mb-3 px-5 bg-white">
              <AccordionTrigger className="text-left font-display font-bold text-lg hover:no-underline" data-testid={`faq-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="text-[#475569] text-base leading-relaxed">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
      <CTABand heading="Still Have Questions?" sub="Our team is happy to help. Call now or request a free estimate — we'll walk you through everything." />
    </>
  );
};

export default FAQ;
